
import Button from '../../../components/base/Button';

export default function ProductCTA() {
  return (
    <section className="bg-red-600 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to Protect Your Property?
          </h2>
          <p className="text-xl text-red-100 mb-8">
            Get a customized quote for our emergency exit signs. Our experts will help you choose the right solution for your evacuation lighting needs.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="outline" 
              className="bg-white text-red-600 border-white hover:bg-red-50 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line mr-2"></i>
              Request Quote
            </Button>
            <Button 
              variant="outline" 
              className="bg-transparent text-white border-white hover:bg-white hover:text-red-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Call +974 5554 4093
            </Button>
          </div>
          
          <div className="mt-8 flex items-center justify-center space-x-8 text-red-100">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-xl"></i>
              <span>QCDD Approved</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-truck-line text-xl"></i>
              <span>Fast Delivery</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-customer-service-2-line text-xl"></i>
              <span>Expert Support</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
